<template>
  <div>
    <table class="center">
      <tbody class="report-container">
        <v-card-text class="pt-0">
          <v-data-table :headers="Headers" :items="Payments" :rows-per-page-items="rowsPerPageItems">
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">
                {{ props.item.createdAt | moment('L LT') }}
              </td>
              <td class="text-xs-left">
                {{ props.item.Employee.name }}
              </td>
              <td data-cy="expenseComponentsListPayeeName" class="text-xs-left">
                {{ props.item.Invoice.localId }}
              </td>
              <td data-cy="expenseComponentsListPayeeName" class="text-xs-left">
                {{ props.item.referenceNumber }}
              </td>
              <td
                data-cy="expenseComponentsListAmount"
                class="text-xs-right text-md-right text-sm-right text-lg-right"
              >
                {{ props.item.amount | currency }}
              </td>
            </template>
            <template slot="footer">
              <tr>
                <td :colspan="Headers && Headers.length - 2">
                  <div class="text-xs-right font-weight-bold">
                    {{ $t('labels.total') }}
                  </div>
                </td>
                <td class="text-xs-right font-weight-bold">
                  {{ getTotal() | currency }}
                </td>
                <td></td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ['Payments', 'Headers'],
  data() {
    return {
      rowsPerPageItems: [10, 25, 50, 100],
    }
  },
  methods: {
    getTotal() {
      let total = 0
      if (this.Payments) {
         this.Payments.map((invoice) => {
        total += parseFloat(invoice.amount)
      })
      }
      return total
    },
  },
}
</script>

<style>
</style>